import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ListViewIcon(props, ref) {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M17 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M4 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zm8 2H4v6h8z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16 10a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
    })]
  });
}
;
ListViewIcon.displayName = "ListViewIcon";
export default forwardRef(ListViewIcon);